import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { http } from "../../lib/api";

export default function TemplatePanel() {
  const [template, setTemplate] = useState(null), [saved, setSaved] = useState(false);
  useEffect(() => { http.get("/settings/email-template").then((r) => setTemplate(r.data)).catch(() => {}); }, []);
  const save = async () => { await http.put("/settings/email-template", template); setSaved(true); setTimeout(() => setSaved(false), 2000); };
  return (
    <>
      <div className="admin-top"><h1>Email template</h1></div>
      <div className="template-panel" id="template">
        <div><p className="eyebrow">Automated reply</p><h2>Lead confirmation</h2><p>Use <code>[Name]</code> and <code>[Service Selected]</code> to personalize new lead confirmations. Replies go to info@mlfabenterprises.com.</p></div>
        {template && <div className="template-form">
          <label>Subject<input value={template.subject} onChange={(e) => setTemplate({ ...template, subject: e.target.value })} data-testid="template-subject-input" /></label>
          <label>Body<textarea value={template.body} onChange={(e) => setTemplate({ ...template, body: e.target.value })} data-testid="template-body-input" /></label>
          <button className="button button-navy" onClick={save} data-testid="template-save-button">{saved ? "Saved" : "Save template"} <CheckCircle2 size={16} /></button>
        </div>}
      </div>
    </>
  );
}
